import React, { useEffect, useState, useRef } from "react";
import { getWithTokenAPI, postWithTokenAPI, postWithoutTokenAPI, putAPI, deleteAPI, UploadDocument } from "../../utils/Api";
import ReactQuill from 'react-quill';
import { modules, formats } from "../../utils/QuillConfig";
import Select from 'react-select';
import { useNavigate } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Createproduct = () => {
    const token = localStorage.getItem("token");
    let navigate = useNavigate()
    const BlogService = {
        create: async (token, createproduct) => {
            return await postWithTokenAPI(token, "/product/create", JSON.stringify(createproduct), true);
        },
    };
    const MetaService = {
        fetchTags: async (token) => {
            return await getWithTokenAPI(token, "/tag/find-all");
        },

        fetchCategories: async (token) => {
            return await getWithTokenAPI(token, "/category/find-all");
        }
    };
    const [state, setState] = useState({
        loading: false,
        error: null,
        isLoading: false,
        tags: [],
        categories: [],
        imageFiles: [],
        previewImages: [],
    });

    const [sellerid, setsellerid] = useState([])
    const [createproduct, setcreateproduct] = useState({
        seller_id: '',
        category_id: "",
        name: "",
        original_price: "",
        discount_price: "",
        stock: "",
        quantity: "",
        variant: "",
        status: "Active",
        short_description: "",
        long_description: "",
        product_image: [],
        tag: []
    });
    console.log(createproduct)

    const [errors, setErrors] = useState({
        seller_id: "",
        category_id: "",
        name: "",
        original_price: "",
        discount_price: "",
        stock: "",
        quantity: "",
        variant: "",
        status: "",
        short_description: "",
        long_description: "",
        product_image: "",
        tag: ""
    });

    useEffect(() => {
        const Sellerdetails = async () => {
            try {
                const response = await getWithTokenAPI(token, "/seller/find-all");
                if (response?.statusCode === 200 || response?.success) {
                    setsellerid(response.data.User)
                }
                else {
                    alert("Failed to create product: " + (response?.message || ""));
                }
            }
            catch (error) {
                alert("Error creating product: " + error.message);
            }
        }
        Sellerdetails()
    }, [])

    const updateState = (newState) => {
        setState(prev => ({ ...prev, ...newState }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            seller_id: "",
            category_id: "",
            name: "",
            original_price: "",
            discount_price: "",
            stock: "",
            quantity: "",
            variant: "",
            status: "",
            short_description: "",
            long_description: "",
            product_image: "",
            tag: ""
        };

        // Seller validation
        if (!createproduct.seller_id) {
            newErrors.seller_id = "Seller is required";
            isValid = false;
        }

        // Category validation
        if (!createproduct.category_id) {
            newErrors.category_id = "Category is required";
            isValid = false;
        }

        // Name validation
        if (!createproduct.name.trim()) {
            newErrors.name = "Product name is required";
            isValid = false;
        }

        // // Tags validation
        // if (!createproduct.tag || createproduct.tag.length === 0) {
        //     newErrors.tag = "At least one tag is required";
        //     isValid = false;
        // }

        // Original price validation
        if (!createproduct.original_price || createproduct.original_price <= 0) {
            newErrors.original_price = "Original price must be greater than 0";
            isValid = false;
        }

        // Discount price validation
        if (createproduct.discount_price === "" || createproduct.discount_price < 0) {
            newErrors.discount_price = "Discount price cannot be negative";
            isValid = false;
        } else if (parseFloat(createproduct.discount_price) > parseFloat(createproduct.original_price)) {
            newErrors.discount_price = "Discount price cannot be greater than original price";
            isValid = false;
        }

        // Stock validation
        if (createproduct.stock === "" || createproduct.stock < 0) {
            newErrors.stock = "Stock must be a positive number";
            isValid = false;
        }

        // Quantity validation
        if (!createproduct.quantity || createproduct.quantity <= 0) {
            newErrors.quantity = "Quantity must be greater than 0";
            isValid = false;
        }

        // Variant validation
        if (!createproduct.variant) {
            newErrors.variant = "Variant is required";
            isValid = false;
        }

        // Short description validation
        if (!createproduct.short_description || createproduct.short_description === "<p><br></p>") {
            newErrors.short_description = "Short description is required";
            isValid = false;
        }

        // Long description validation
        if (!createproduct.long_description || createproduct.long_description === "<p><br></p>") {
            newErrors.long_description = "Long description is required";
            isValid = false;
        }

        // Image validation
        if (!createproduct.product_image || createproduct.product_image.length === 0) {
            newErrors.product_image = "At least one image is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleCreateproduct = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }
        updateState({ isLoading: true });
        try {
            const response = await BlogService.create(token, createproduct);
            if (response?.statusCode === 200 || response?.success) {
                toast.success("Product created successfully.");
                navigate("/productmanagement")
            } else {
                toast.error("Failed to create product: " + (response?.message || ""));
            }
        } catch (error) {
            toast.error("Error creating product: " + error.message);
        } finally {
            updateState({ isLoading: false });
        }
    };

    const fetchTagsAndCategories = async () => {
        try {
            const [tagsRes, catRes] = await Promise.all([
                MetaService.fetchTags(token),
                MetaService.fetchCategories(token)
            ]);

            const newState = {};
            if (tagsRes?.statusCode === 200) {
                newState.tags = tagsRes.data.tags.map(tag => ({
                    value: tag._id,
                    label: tag.name
                }));
            }
            if (catRes?.statusCode === 200) {
                newState.categories = catRes.data.categories.map(category => ({
                    value: category._id,
                    label: category.category_name
                }));
            }
            updateState(newState);
        } catch (err) {
            alert("Error fetching metadata", err);
        }
    };
    useEffect(() => {
        fetchTagsAndCategories();
    }, [state.statusFilter]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setcreateproduct(prev => ({ ...prev, [name]: value }));
        // Clear error when user starts typing
        setErrors(prev => ({ ...prev, [name]: "" }));
    };

    const handleshortDescriptionChange = (value) => {
        setcreateproduct(prev => ({ ...prev, short_description: value }));
        setErrors(prev => ({ ...prev, short_description: "" }));
    };

    const handlelongDescriptionChange = (value) => {
        setcreateproduct(prev => ({ ...prev, long_description: value }));
        setErrors(prev => ({ ...prev, long_description: "" }));
    };

    const handleTagsChange = (selectedOptions) => {
        setcreateproduct(prev => ({
            ...prev,
            tag: selectedOptions ? selectedOptions.map(option => option.label) : []
        }));
        setErrors(prev => ({ ...prev, tag: "" }));
    };

    const handleCreateImage = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });
        formData.append('path', 'media/');

        try {
            const response = await postWithoutTokenAPI('/files/upload', formData);

            if (response.error) {
                throw new Error(response.error);
            }
            else if (response?.statusCode === 200) {
                const uploadedUrls = response.data[0].file_url || [];
                setcreateproduct(prev => ({
                    ...prev,
                    product_image: [uploadedUrls, ...(prev.product_image || [])]
                }));
                setErrors(prev => ({ ...prev, product_image: "" }));

                // Create preview images
                const newPreviews = files.map(file => URL.createObjectURL(file));
                updateState({ previewImages: [...state.previewImages, ...newPreviews] });
            }

        } catch (error) {
            console.error('Error uploading images:', error);
            alert('Failed to upload images. Please try again.');
        }
    };

    return (
        <div className="createcontainer">
            <div className="createname pb-2 text-start">
                <h4>Create Product</h4>
            </div>
            <form onSubmit={handleCreateproduct} className="createform">
                <div className="modal-body mt-4">
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                                name="name"
                                value={createproduct.name}
                                onChange={handleInputChange}
                                placeholder="Enter Product Name"
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Original Price</label>
                            <input
                                type="number"
                                className={`form-control ${errors.original_price ? "is-invalid" : ""}`}
                                name="original_price"
                                value={createproduct.original_price}
                                onChange={handleInputChange}
                                min="0"
                                step="0.01"
                            />
                            {errors.original_price && <div className="invalid-feedback">{errors.original_price}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Discount Price</label>
                            <input
                                type="number"
                                className={`form-control ${errors.discount_price ? "is-invalid" : ""}`}
                                name="discount_price"
                                value={createproduct.discount_price}
                                onChange={handleInputChange}
                                min="0"
                                step="0.01"
                                max={createproduct.original_price || ""}
                            />
                            {errors.discount_price && <div className="invalid-feedback">{errors.discount_price}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Quantity</label>
                            <input
                                type="number"
                                className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
                                name="quantity"
                                value={createproduct.quantity}
                                onChange={handleInputChange}
                                min="1"
                            />
                            {errors.quantity && <div className="invalid-feedback">{errors.quantity}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Stock</label>
                            <input
                                type="number"
                                className={`form-control ${errors.stock ? "is-invalid" : ""}`}
                                name="stock"
                                value={createproduct.stock}
                                onChange={handleInputChange}
                                min="0"
                            />
                            {errors.stock && <div className="invalid-feedback">{errors.stock}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Categories</label>
                            <select
                                value={createproduct.category_id}
                                name="category_id"
                                className={`form-select ${errors.category_id ? "is-invalid" : ""}`}
                                onChange={handleInputChange}
                            >
                                <option value="" disabled selected>Select...</option>
                                {
                                    state.categories.map((element) => {
                                        return (
                                            <option key={element.value} value={element.value}>
                                                {element.label}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            {errors.category_id && <div className="invalid-feedback">{errors.category_id}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-lable">Seller name</label>
                            <select
                                className={`form-select ${errors.seller_id ? "is-invalid" : ""}`}
                                name="seller_id"
                                value={createproduct.seller_id}
                                onChange={handleInputChange}
                            >
                                <option value="" disabled selected>Select...</option>
                                {
                                    sellerid.map((seller) => {
                                        return (
                                            <option key={seller._id} value={seller._id}>{seller.name}</option>
                                        )
                                    })
                                }
                            </select>
                            {errors.seller_id && <div className="invalid-feedback">{errors.seller_id}</div>}
                        </div>

                        {/* <div className="col-md-3 mb-3">
                            <label className="form-label">Tags</label>
                            <Select
                                isMulti
                                options={state.tags}
                                value={state.tags.filter(tag => createproduct.tag.includes(tag.label))}
                                onChange={handleTagsChange}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                name="tags"
                            />
                            {errors.tag && <div className="invalid-feedback d-block">{errors.tag}</div>}
                        </div> */}

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Status</label>
                            <select
                                className="form-select"
                                name="status"
                                value={createproduct.status}
                                onChange={handleInputChange}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>

                        <div className="col-md-4 mb-3">
                            <label className="form-label">Variant</label>
                            <select
                                className={`form-select ${errors.variant ? "is-invalid" : ""}`}
                                name="variant"
                                value={createproduct.variant}
                                onChange={handleInputChange}
                            >
                                <option value="" disabled selected>Select...</option>
                                <option value="KG">KG</option>
                                <option value="GM">GM</option>
                                <option value="Litre">Litre</option>
                                <option value="ML">ML</option>
                                <option value="Pcs">Pcs</option>
                                <option value="Box">Box</option>
                                <option value="Bottle">Bottle</option>
                                <option value="Packet">Packet</option>
                                <option value="Set">Set</option>
                                <option value="Pair">Pair</option>
                            </select>
                            {errors.variant && <div className="invalid-feedback">{errors.variant}</div>}
                        </div>

                        <div className="col-12 mb-3">
                            <label className="form-label">Short Description</label>
                            <ReactQuill
                                theme="snow"
                                value={createproduct.short_description}
                                onChange={handleshortDescriptionChange}
                                modules={modules}
                                formats={formats}
                                name="short_description"
                                placeholder="Enter Short Description"
                                className={errors.short_description ? "is-invalid" : ""}
                            />
                            {errors.short_description &&
                                <div className="invalid-feedback d-block">{errors.short_description}</div>
                            }
                        </div>

                        <div className="col-12 mb-3">
                            <label className="form-label">Long Description</label>
                            <ReactQuill
                                theme="snow"
                                value={createproduct.long_description}
                                onChange={handlelongDescriptionChange}
                                modules={modules}
                                formats={formats}
                                name="long_description"
                                placeholder="Enter Long Description"
                                className={errors.long_description ? "is-invalid" : ""}
                                style={{height:"120px" , marginBottom:"50px"}}
                            />
                            {errors.long_description &&
                                <div className="invalid-feedback d-block">{errors.long_description}</div>
                            }
                        </div>

                        <div className="col-12 mb-3">
                            <label className="form-label">Images</label>
                            <input
                                type="file"
                                className={`form-control ${errors.product_image ? "is-invalid" : ""}`}
                                multiple
                                onChange={handleCreateImage}
                                accept="image/*"
                            />
                            {errors.product_image &&
                                <div className="invalid-feedback d-block">{errors.product_image}</div>
                            }
                            <div className="d-flex flex-wrap mt-5">
                                {state.previewImages.map((img, index) => (
                                    <div key={index} className="me-2 mb-2" style={{ width: '100px', position: 'relative' }}>
                                        <img
                                            src={img}
                                            alt={`Preview ${index}`}
                                            className="img-thumbnail"
                                            style={{ width: '100%', height: '100px', objectFit: 'cover' }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            style={{
                                                position: 'absolute',
                                                top: '0',
                                                right: '0',
                                                padding: '0.1rem 0.3rem'
                                            }}
                                            onClick={() => {
                                                const newPreviews = [...state.previewImages];
                                                newPreviews.splice(index, 1);
                                                updateState({ previewImages: newPreviews });

                                                const newImages = [...createproduct.product_image];
                                                newImages.splice(index, 1);
                                                setcreateproduct(prev => ({
                                                    ...prev,
                                                    product_image: newImages
                                                }));
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => { navigate("/backoffice/productmanagement") }}
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        className="Createproductbutton "
                        disabled={state.isLoading}
                    >
                        {state.isLoading ? "Creating..." : "Create Product"}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default Createproduct